import { render } from "./LanguagePickerGrid.vue?vue&type=template&id=3affcffe&scoped=true"
import script from "./LanguagePickerGrid.vue?vue&type=script&lang=js"
export * from "./LanguagePickerGrid.vue?vue&type=script&lang=js"

import "./LanguagePickerGrid.vue?vue&type=style&index=0&id=3affcffe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3affcffe"]])

export default __exports__